import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import moment from 'moment';
import TimerForRate from '../TimerForRate';
import Alert from 'react-s-alert';
import { delay } from 'lodash';
import { PatientRecordRateAction, isRecordRateStart, rateValueStaticArrayAction, resetRateTimer, SavePatientRecordRateData, resetCustomRateArray } from '../../actions/BehaviourDataActions';
import Loader from '../../../../../../../../img/loader.gif';
import RecordRateDataViewModal from './RecordRateDataViewModal';
import { alertConfirmation } from '../../../../../../../../actions/utilAction';
import DurationGraphModal from '../../RateGraphModal';

class RecordRate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            FromDate: new Date(),
            RateArray: props.customRateArray,
            Id: [],
            DoNotZeroOut: [],
            isStart: props.isStart,
            isSave: props.isSave,
            secondsElapsed: props.secondsElapsed,
            incrementer: props.incrementer,
            todayRecordRateDataViewModal: false,
            rateGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
            recordingTypeName:'Rate',
            alertRaiserIndex:[]
        }
    }

    renderLoading() {
        if (this.state.isLoading) {
            return (
                <div className="full_loader">
                    <div className="circle_loader page_loader">
                        <img src={Loader} alt="" />
                    </div>
                </div>
            );
        }
    }

    componentWillMount = () => {
        this.props.PatientRecordRateAction(this.state.patientId)
    }
    
    componentWillUnmount(){
       this.setState((prevState)=>{
        alertRaiserIndex:[]
       })
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.recordRateDataList.data !== undefined) {
            let Id = this.state.Id, DoNotZeroOut = this.state.DoNotZeroOut;
            let patientBehaviorsRateData = nextProps.recordRateDataList.data.PatientBehaviorsReductionData;
            patientBehaviorsRateData.map((obj, index) => {
                return Id[index] = obj.id;
            })
            patientBehaviorsRateData.map((obj, index) => {
                return DoNotZeroOut[index] = obj.doNotZeroOut;
            })
            this.setState({
                Id: Id, DoNotZeroOut: DoNotZeroOut
            })
        }
    }

    handleClose = () => {
        this.setState({
            todayRecordRateDataViewModal: false,
            rateGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
        })
    }

    onGraphHandler(e,obj){
        e.preventDefault();
        this.setState({
            rateGraphModalOpen: true,
            modalTitle: obj.behaviorName,
            behaviorsReductionId: obj.id
        })
    }

    todayRecordRateDataView = () => {
        this.setState({
            todayRecordRateDataViewModal : true
        })
        
    }

    alertRaiser = (type, index)=>{
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
              handleButtonClick: ()=>this.rateClickHandler(type, index),
              // id: obj.id,
            },
          });
    }


    rateClickHandler = (type, index) => {
        Alert.closeAll()
        if (type === "Minus" && this.props.customRateArray[index] !== undefined && this.props.customRateArray[index] > 0) {
            this.props.rateValueStaticArrayAction("Minus", index)
            
            
        } else if (type === "Plus") {
            this.props.rateValueStaticArrayAction("Plus", index)
            this.setState((prevState)=>({
                alertRaiserIndex:[...prevState.alertRaiserIndex,index]
              }))
        }

    }

    handleStart = () => {
        this.props.isRecordRateStart(true)
        let isStart = this.state.isStart
        isStart = true
        this.setState({
            isStart: isStart
        });
    }

    handleStop = () => {
        let isStart = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        isStart = false
        isSave = true
        this.setState({
            isStart: isStart,
            isSave: isSave,
            secondsElapsed: counterData
        }, () => {clearInterval(this.state.incrementer[0]), clearInterval(this.props.newIncrementer[0]),this.props.isRecordRateStart(false)});
    }

    handleCancel = () => {
        Alert.closeAll()
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        clikcedData = false
        isSave = false
        counterData = 0;
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData,
            RateArray: []
        }, () => { clearInterval(this.state.incrementer[0]), clearInterval(this.props.newIncrementer[0]),this.props.resetRateTimer(),this.props.isRecordRateStart(false), this.props.resetCustomRateArray()})

    }

    handleCancelConfirmation = () => {
        alertConfirmation('Are you sure you want to cancel Rate Details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleCancel,
            }
        });
    }


    handleSave = () => {
        let minutes = Math.floor(this.props.secondsElapsed / 60);
        let seconds = Math.floor(this.props.secondsElapsed % 60);

        let patientId = this.state.patientId;
        let createdDate = this.state.creadtedDate;
        let uuid = this.props.uuid;

        if (seconds < 10) {
            seconds = `0${seconds}`
        }
        let duration = minutes+"."+seconds
        let finalData = [];
        this.state.Id.map((obj, index) => {        
            if(this.props.customRateArray[index] > 0 || this.state.DoNotZeroOut[index] === true) {
                let patientRecordFrequencyDataDetailsModelData = {
                    "recordRateDataDetailId": 0,
                    "recordRateDataId": 0,
                    "behaviorsReductionId": obj,                
                    "value": this.props.customRateArray[index]
                }
                finalData.push(patientRecordFrequencyDataDetailsModelData);
            }            
        })
        let postData = {
            "id": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            "patientRecordRateDataDetailsModel": finalData,
            "duration": duration,
        }
        this.props.SavePatientRecordRateData(postData,{
            patientId,
            createdDate,
            uuid
        });
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        counterData = 0;
        clikcedData = false
        isSave = false
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData,
            RateArray: []
        }, () => { clearInterval(this.state.incrementer[0]), clearInterval(this.props.newIncrementer[0]), this.props.resetRateTimer(), this.props.resetCustomRateArray() });
    }

    renderData = (dataList) => {
        let PatientRecordRateData = dataList || [];
        if (!PatientRecordRateData.length) {
            return (
                <tr>
                    <td colSpan='3'>
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientRecordRateData.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>
                        {Obj.behaviorName}
                    </td>
                    <td>
                        {Obj.description}
                    </td>
                    <td>
                        <div className='row'>
                            <div className="col-sm-1"> </div>
                            <div className="col-sm-3">
                                {this.state.isSave === false && <button
                                    name={`rateMinus${index}`}
                                    className="tableadd"
                                    title="Minus"
                                    type="button"
                                    onClick={() => this.rateClickHandler("Minus", index)}
                                >
                                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                </button>}
                            </div>
                            <div className="col-sm-3">{this.props.customRateArray[index] || 0}</div>
                            <div className="col-sm-3">
                                {this.state.isSave === false && <button
                                    name={`ratePlus${index}`}
                                    className="tableadd"
                                    title="Plus"
                                    type="button"
                                    onClick={() => this.props.recordRateDataList.data.PatientBehaviorsReductionData[index].isDataCollectedInDailySummaryData  && !(!`${index}` in this.state.RateArray) && !(this.state.alertRaiserIndex.includes(index))? this.alertRaiser("Plus", index):this.rateClickHandler("Plus", index)}
                                    // onClick={()=>{
                                    //     console.log(this.props.recordRateDataList.data.PatientBehaviorsReductionData[index].isDataCollectedInDailySummaryData)
                                    //     console.log(!`${index}` in this.state.RateArray);

                                    // }}
                                >
                                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                                </button>}
                            </div>
                            <div className="col-sm-2"> </div>
                        </div>
                    </td>
                    <td>
                        {/* {(this.state.targetType && this.state.targetType[index])?( */}
                            <button type="button" onClick={(e) => this.onGraphHandler(e,Obj)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                        {/* ):''} */}
                    </td>  
                </tr>
            )
        })
    }

    renderRecordRate = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { recordRateDataList } = this.props;
        let RecordRateDataList = (recordRateDataList && recordRateDataList.data) || [];
        return (
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="20%">Rate</th>
                            <th width="40%">Operational Definition</th>
                            <th width="30%"></th>
                            <th width="10%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(RecordRateDataList.PatientBehaviorsReductionData)}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-4 col-sm-4 col-md-4">
                                {(this.state.isStart === false && this.state.isSave === false) && this.props.addPermissionBehavior && 
                                    <RaisedButton
                                        label="START"
                                        className='startButton'
                                        primary={true}
                                        onTouchTap={() => this.handleStart()} />
                                }
                                {(this.state.isStart === true && this.state.isSave === false) &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="STOP"
                                                className='stopButton'
                                                primary={true}
                                                onTouchTap={() => this.handleStop()} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CANCEL"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation()} />
                                        </span>
                                    </div>
                                }
                                {this.state.isSave === true &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="SAVE"
                                                primary={true}
                                                onTouchTap={() => this.handleSave()} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CANCEL"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation()} />
                                        </span>
                                    </div>
                                }
                            </div>
                            <div className="col-4 col-sm-4 col-md-4">
                                {this.state.isStart || this.state.isSave ? <TimerForRate /> : '0:00'}
                            </div>
                            <div className="col-4 col-sm-4 col-md-4 btn_rt reset-btn claims_filter">
                                <RaisedButton
                                    style={{ marginTop: '10px', marginRight: '22px', float: 'right' }}
                                    className="ml_15"
                                    onClick={() => this.todayRecordRateDataView()}
                                    label="Today's Rate Data"
                                    primary={true}>
                                </RaisedButton>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderRecordRate()}
                {
                    this.state.rateGraphModalOpen &&
                    <DurationGraphModal
                    patientId={this.state.patientId}
                    closeDialog={() => this.handleClose()}
                    recordingTypeName={this.state.recordingTypeName}
                    behaviorsReductionId={this.state.behaviorsReductionId}
                    modalTitle={this.state.modalTitle}
                    />
                }
                <div>
                    {
                        this.state.todayRecordRateDataViewModal && <RecordRateDataViewModal
                            patientId={this.state.patientId}
                            creadtedDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                            uuid={this.props.uuid}
                            closeDialog={() => this.handleClose()}
                            updatePermissionBehavior = {this.props.updatePermissionBehavior}
                            deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                        />
                    }
                </div>
            </div>
        )
    }
}

RecordRate = reduxForm({
    form: 'RecordRateForm',
    enableReinitialize: true,
})(RecordRate);

function mapStateToProps(state) {
    return {
        loading: state.patientRecordRateCustomReducer.loading,
        recordRateDataList: state.patientRecordRateCustomReducer.patientRecordRateList !== null ? state.patientRecordRateCustomReducer.patientRecordRateList : [],
        uuid: state.patientSkillAcqActiveProgram.uuid,

        isStart: state.patientRecordRateCustomReducer.isStart,
        isSave: state.patientRecordRateCustomReducer.isSave,
        secondsElapsed: state.patientRecordRateCustomReducer.secondsElapsed,
        incrementer: state.patientRecordRateCustomReducer.incrementer,
        newIncrementer: state.patientRecordRateCustomReducer.newIncrementer,
        customRateArray: Object.assign({},state.patientRecordRateCustomReducer.customRateArray),
    }
}

export default connect(mapStateToProps, { PatientRecordRateAction,rateValueStaticArrayAction, isRecordRateStart,resetCustomRateArray, resetRateTimer, SavePatientRecordRateData })(RecordRate);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordRate/RecordRate.js